export const getOffsetFromUrl = (next: string): number | null => {
  try {
    const urlParams = new URLSearchParams(new URL(next).search);
    const offset = urlParams.get('offset');
    return offset !== null ? Number(offset) : null;
  } catch (error) {
    console.error('Invalid URL:', next);
    return null;
  }
};
